<template>
  <a-card title="推荐规则" :bordered="false">
    <div style="margin-bottom: 20px;">
      <a-button type="primary" @click="addRecommendationEvent">添加推荐</a-button>
      <a-button type="primary" @click="recommendedSettings" style="margin-left: 20px;">推荐设置</a-button>
    </div>
    <custom-page-table
      ref="table"
      :query-params="queryParams"
      query-path="propose/getProposeList"
      base-key="serviceUrl"
      :columns="getColumns()"
    >
      <span slot="action" slot-scope="rowItem">
        <a @click="toEditor(rowItem.record)">修改</a>
        <template v-if="rowItem.record.proposeDefaultState!==1">
          <a-divider type="vertical"></a-divider>
        <a-popconfirm title="是否要删除当前规则？" @confirm="deleteEvent(rowItem.record)">
          <a>删除</a>
        </a-popconfirm>
        </template>
      </span>
    </custom-page-table>
    <a-modal
      :title="ruleForm.proposeId?'编辑推荐':'添加推荐'"
      okText="保存设置"
      :width="800"
      v-model="showDialog"
      @ok="saveEvent"
      @cancel="showDialog = false"
      :confirmLoading="saveLoading"
    >
      <a-form-model
        :label-col="currentFormLayout.labelCol"
        :wrapper-col="currentFormLayout.wrapperCol"
        ref="form"
        :model="ruleForm"
        :rules="rules"
      >
        <a-form-model-item label="推荐名称" prop="proposeName">
          <a-input
            :disabled="ruleForm.proposeDefaultState===1"
            v-model="ruleForm.proposeName"
            style="width: 100%;"
            placeholder="最多30个字"></a-input>
        </a-form-model-item>
        <a-form-model-item label="规则方式" prop="proposeRule">
          <a-select
            :disabled="ruleForm.proposeId > 0"
            v-model="ruleForm.proposeRule"
            placeholder="请选择"
            style="width: 100%;"
          >
            <a-select-option v-for="item in proposeRuleList" :key="item.code" :value="item.code"
            >{{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item v-if="ruleForm.proposeRule >= 0 && ruleForm.proposeRule < 3" label="优先级">
          <span v-if="ruleForm.proposeRule == 0">3级</span>
          <span v-else-if="ruleForm.proposeRule == 1">2级</span>
          <span v-else-if="ruleForm.proposeRule == 2">1级</span>
          数字越小，优先级越高
        </a-form-model-item>
        <a-form-model-item label="展示位置" prop="proposePlace" :required="ruleForm.proposeDefaultState===1?false:true">
          <a-checkbox-group v-model="ruleForm.proposePlace" :disabled="ruleForm.proposeDefaultState===1">
            <a-checkbox v-for="item in proposePlaceList" :key="item.code" :value="item.code">{{
                item.name
              }}
            </a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
        <a-form-model-item v-if="ruleForm.proposeRule == 1" label="指定品类">
          <a-checkbox-group v-model="ruleForm.proposeProType">
            <a-checkbox v-for="item in proTypeList" :key="item.code" :value="item.code">{{ item.name }}</a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
        <a-form-model-item label="推荐商品">
          <span style="margin-bottom: 20px;">
            <a-button type="primary" @click="onRelationEvent" style="margin-right: 10px; margin-bottom: 20px;"
            >关联</a-button
            >
            最多推荐30个商品
          </span>
          <a-table
            :bordered="true"
            :dataSource="selectedProductList"
            :pagination="false"
            :columns="getRelationGoodsColumns()"
            rowKey="relatedProId"
          >
            <template slot="relatedProType" slot-scope="text">{{ text | productTypeName }}</template>
            <template slot="action" slot-scope="text, record">
              <a-button size="small" type="danger" @click="onRemoveEvent(record)">移除</a-button>
            </template>
          </a-table>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <selected-product-dialog
      :show="showSelectedDialog"
      :itemNames="['search_proId', 'search_proName']"
      :query-params="selectedQueryParams"
      params-path="public/getGoodsList"
      base-key="proUrl"
      row-key="proId"
      @close="showSelectedDialog = false"
      :columns="getGoodsColumns()"
    >
      <a-form-item label="商品ID" slot="search_proId" v-bind="selectedFormLayout">
        <a-input v-model="selectedQueryParams.proId" style="width: 170px;" placeholder="请输入商品ID"></a-input>
      </a-form-item>
      <a-form-item label="商品名称" slot="search_proName" v-bind="selectedFormLayout">
        <a-input
          v-model="selectedQueryParams.proName"
          style="width: 170px;"
          placeholder="请输入商品名称"
        ></a-input>
      </a-form-item>
      <template slot="proCatalogId" slot-scope="rowItem">{{ rowItem.text | productTypeName }}</template>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onSelectedResult(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>
    <a-modal
      title="推荐设置"
      okText="保存修改"
      :width="800"
      v-model="showSettingDialog"
      @ok="saveEvent(2)"
      @cancel="showSettingDialog = false"
      :confirmLoading="saveLoading"
    >
      <a-form-model
        :label-col="currentFormLayout.labelCol"
        :wrapper-col="currentFormLayout.wrapperCol"
        ref="settingForm"
        :model="settingForm"
        :rules="settingRules"
      >
        <a-form-model-item label="详情页名称" prop="proposeSiteDetailsName">
          <a-input v-model="settingForm.proposeSiteDetailsName" style="width: 100%;" placeholder="最多6个字"></a-input>
        </a-form-model-item>
        <a-form-model-item label="支付结果页" prop="proposeSitePayName">
          <a-input v-model="settingForm.proposeSitePayName" style="width: 100%;" placeholder="最多6个字"></a-input>
        </a-form-model-item>
        <a-form-model-item label="排行榜">
          <a-radio-group v-model="settingForm.proposeSiteRankingState">
            <a-radio :value="0">关闭</a-radio>
            <a-radio :value="1">开启</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import formMixin from '@/utils/mixins/formMixins'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'

export default {
  name: 'RelatedRecommendation',
  mixins: [formMixin],
  components: { SelectedProductDialog },
  mounted() {
  },
  data() {
    return {
      currentFormLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 }
      },
      selectedFormLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      queryParams: {},
      showDialog: false,
      ruleForm: {
        proposeId: 0,// 关联推荐ID
        proposeName: '',//关联推荐名称
        proposePlace: [],//展示位置
        proposePriority: '',//推荐优先级
        proposeProType: [],//商品类型
        proposeRule: '',// 关联推荐规则 0全局推荐 1指定品类 2指定商品
        relatedProList: []
      },
      rules: {
        proposeName: [
          { required: true, message: '请输入联推荐名称', trigger: 'blur' }
        ],
        proposeRule: [
          { required: true, message: '请选择规则方式', trigger: 'change' }
        ],
        proposePlace: [
          { type: 'array', message: '请至少选择一个展示位置', trigger: 'change' }
          , { validator: this.valProposePlace }
        ],
        proposeProType: [
          { type: 'array', required: true, message: '请至少选择一个商品类型', trigger: 'change' }
        ]
      },
      proposePlaceList: [],
      proposeRuleList: [],
      proposeProTypeList: [],
      selectedProductList: [],
      proTypeList: [],
      selectedQueryParams: {},
      showSelectedDialog: false,
      showSettingDialog: false,
      settingForm: {
        proposeSiteDetailsName: '',
        proposeSiteId: 0,
        proposeSitePayName: '',
        proposeSiteRankingState: 0
      },
      settingRules: {
        proposeSiteDetailsName: [
          { required: true, message: '请输入详情页面名称', trigger: 'blur' }
          , { validator: this.validatorProposeName }
        ],
        proposeSitePayName: [
          { required: true, message: '请输入支付结果页面名称', trigger: 'blur' }
          , { validator: this.validatorProposeName }

        ]
      }
    }
  },

  created() {
    this.queryParams = {
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId
    }
    this.proTypeList = this.getAppConstants().getProductTypeList()
    this.getBaseData()
  },
  methods: {
    validatorProposeName(rule, value, callback) {
      if (value && value.length > 6) {
        callback(new Error('最多只能6个字'))
      } else {
        callback()
      }
    },
    valProposePlace(rule, value, callback) {
      if (this.ruleForm.proposeDefaultState != 1) {
        if (value && value.length > 0) {
          callback()
        } else {
          callback(new Error('请至少选择一个展示位置'))
        }
      } else {
        callback()
      }
    },
    //获取基本数据
    getBaseData() {
      this.getHttpServices().getServerApiService().get('propose/getProposeBasicParam')
        .then(data => {
          this.proposePlaceList = data.proposePlace
          this.proposeRuleList = data.proposeRule
          this.proposeProTypeList = data.proposeProType
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    addRecommendationEvent() {
      this.ruleForm = {}
      this.selectedProductList = []
      this.showDialog = true
    },
    recommendedSettings() {
      this.getHttpServices().getServerApiService().post('propose/getProPoseSite', this.queryParams)
        .then(detail => {
          this.settingForm = { ...detail }
          this.showSettingDialog = true
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    toEditor(record) {
      this.getRuleDetails(record.proposeId)
        .then(detail => {
          this.selectedProductList = detail.relatedProList ? detail.relatedProList : []
          detail.relatedProList = undefined,
            this.ruleForm = {
              ...detail,
              proposeId: record.proposeId,
              proposeDefaultState: record.proposeDefaultState
            }
          this.showDialog = true
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getRuleDetails(proposeId) {
      return new Promise((resolve, reject) => {
        this.getHttpServices().getServerApiService().get('propose/getProposeInfo', { proposeId: proposeId })
          .then(detail => {
            if (detail.proposeProType != null) {
              detail.proposeProType = this.getNumberArr(detail.proposeProType)
            }
            if (detail.proposePlace != null) {
              detail.proposePlace = this.getNumberArr(detail.proposePlace)
            }
            if (detail.relatedProList === null) {
              detail.relatedProList = []
            }
            detail.relatedProList = detail.relatedProList ? detail.relatedProList : []
            resolve(detail)
          }).catch(reason => reject(reason))
      })
    },
    deleteEvent(record) {
      const path = 'propose/removePropose?proposeId=' + record.proposeId
      this.getHttpServices().getServerApiService().post(path, {})
        .then(res => {
          this.$message.success('删除成功')
          this.$refs.table.refresh()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'proposeId',
          width: '60px'
        },
        {
          title: '推荐名称',
          dataIndex: 'proposeName'
        },
        {
          title: '规则方式',
          dataIndex: 'proposeRuleStr',
          width: '200px'
        },
        {
          title: '展示位置',
          dataIndex: 'proposePlace',
          width: '200px'
        },
        {
          title: '优先级',
          dataIndex: 'proposePriority',
          width: '80px'
        },
        {
          title: '创建时间',
          dataIndex: 'proposeCreateTime',
          width: '160px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getGoodsColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'proId',
          width: '100px'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '商品分类',
          dataIndex: 'proCatalogId',
          width: '100px',
          scopedSlots: { customRender: 'proCatalogId' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getRelationGoodsColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'relatedProId',
          width: '100px'
        },
        {
          title: '商品名称',
          dataIndex: 'relatedProName'
        },
        {
          title: '商品分类',
          dataIndex: 'relatedProType',
          width: '100px',
          scopedSlots: { customRender: 'relatedProType' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    saveEvent(type) {
      const formName = type === 2 ? 'settingForm' : 'form'
      this.getSubmitFormParams(formName)
        .then(values => {
          if (type === 2) {
            this.settingRequest()
          } else {
            this.addRequest()
          }
        }).catch(reason => this.getLogUtils().errorWithTag('validateFormParams', this.ruleForm))
    },
    addRequest() {
      this.saveLoading = true
      this.ruleForm.limitMerchantId = this.queryParams.limitMerchantId
      this.updateProposeInfo().then(res => {
        this.showDialog = false
        this.$message.success('商品添加成功')
        this.$refs.table.refresh(true)
      }).finally(() => this.saveLoading = false)
    },
    settingRequest() {
      this.saveLoading = true
      this.getHttpServices().getServerApiService().post('propose/editProPoseSite', this.settingForm)
        .then(res => {
          this.showSettingDialog = false
          this.$message.success('修改成功')
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.saveLoading = false)
    },
    //关联
    onRelationEvent() {
      this.getSubmitFormParams('form')
        .then(values => {
          if (this.ruleForm.proposeId) {
            this.showSelectedProductDialog()
          } else {
            this.updateProposeInfo()
              .then(id => {
                this.ruleForm.proposeId = id
                this.showSelectedProductDialog()
              }).catch(reason => this.showNetWorkErrorMessage(reason))
          }
        }).catch(reason => this.getLogUtils().errorWithTag('onRelationEvent', reason))
    },
    showSelectedProductDialog() {
      this.selectedQueryParams = {
        proName: '',
        proNo: '',
        proId: '',
        shopProSource: '',
        shelfStatus: '1'
      }
      this.showSelectedDialog = true
    },
    onSelectedResult(record) {
      const index = this.selectedProductList.findIndex(item => item.relatedProId === record.proId)
      if (index >= 0) {
        this.$message.success('当前选中的商品 被关联，请重新选择！')
        return
      }
      if (this.selectedProductList.length > 30) {
        this.$message.success('最多只只能关联30个商品')
        this.showSelectedDialog = false
        return
      }
      const url = 'propose/editProposeRelatedPro?proposeId=' + this.ruleForm.proposeId
      const newItem = {
        relatedId: 0,
        relatedProId: record.proId,
        relatedProName: record.proName,
        relatedProType: record.proCatalogId
      }
      const params = [...this.selectedProductList, newItem]
      this.getHttpServices().getServerApiService().post(url, params)
        .then(res => {
          this.showSelectedDialog = false
          return this.getRuleDetails(this.ruleForm.proposeId)
        }).then(detail => {
        this.selectedProductList = detail.relatedProList ? detail.relatedProList : []
        this.$message.success('添加成功')
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onRemoveEvent(record) {
      if (record.relatedId) {
        this.getHttpServices().getServerApiService().post('propose/removeProposeRelatePro?relatedId=' + record.relatedId)
          .then(res => {
            this.removeSuccess(record)
          }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.removeSuccess(record)
      }
    },
    removeSuccess(record) {
      this.$message.success('移除成功')
      this.selectedProductList = this.selectedProductList.filter(item => item.relatedId !== record.relatedId)
    },
    updateProposeInfo() {
      const params = {
        proposePriority: '',
        proposeId: 0,
        ...this.queryParams,
        ...this.ruleForm
      }
      params.proposePlace = params.proposePlace && params.proposePlace.length > 0 ? params.proposePlace.join(',') : ''
      params.proposeProType = params.proposeProType && params.proposeProType.length > 0 ? params.proposeProType.join(',') : ''
      return this.getHttpServices().getServerApiService().post('propose/editProposeInfo', params)
    },
    getNumberArr: function(str) {
      if (str) {
        const numbers = str.split(',')
        for (let i = 0, len = numbers.length; i < len; i++) {
          numbers[i] = Number.parseInt(numbers[i])
        }
        return numbers
      }
      return []
    }
  }

}
</script>
<style scoped>
.image {
  height: 104px;
  width: 104px;
}
</style>